import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { is } from 'ramda';

import styles from './Box.module.scss';

const s = classNames.bind(styles);

const Box = React.forwardRef(
	(
		{
			className,
			children, // flex
			displayFlex,
			displayFlexCenter,
			displayFlexCenterSpaceBetween,
			justifyContent,
			flexDirection,
			flexGap,
			flexGrow,
			flexWrap,
			alignItems, // margin
			margin,
			marginTop,
			marginBottom,
			marginRight,
			marginLeft, // padding
			padding,
			paddingTop,
			paddingBottom,
			paddingRight,
			paddingLeft, // border,
			border,
			borderTop,
			borderBottom,
			borderRight,
			borderLeft,
			withBorderRadius,
			position, // position
			style, // inline style
			...other
		},
		ref
	) => (
		<div
			className={s('container', {
				// flex
				displayFlex,
				displayFlexCenter,
				displayFlexCenterSpaceBetween,
				[`justifyContent_${justifyContent}`]: is(String, justifyContent),
				[`alignItems_${alignItems}`]: is(String, alignItems),
				[`flexDirection_${flexDirection}`]: is(String, flexDirection),
				[`flexGap_${flexGap}`]: is(String, flexGap),
				[`flexWrap_${flexWrap}`]: is(String, flexWrap),
				[`flexGrow_${flexGrow}`]: is(String, flexGrow),
				// margin
				[`margin_${margin}`]: is(String, margin),
				[`marginTop_${marginTop}`]: is(String, marginTop),
				[`marginBottom_${marginBottom}`]: is(String, marginBottom),
				[`marginRight_${marginRight}`]: is(String, marginRight),
				[`marginLeft_${marginLeft}`]: is(String, marginLeft),
				// padding
				[`padding_${padding}`]: is(String, padding),
				[`paddingTop_${paddingTop}`]: is(String, paddingTop),
				[`paddingBottom_${paddingBottom}`]: is(String, paddingBottom),
				[`paddingRight_${paddingRight}`]: is(String, paddingRight),
				[`paddingLeft_${paddingLeft}`]: is(String, paddingLeft),
				// border
				[`border_${border}`]: is(String, border),
				[`borderTop_${borderTop}`]: is(String, borderTop),
				[`borderBottom_${borderBottom}`]: is(String, borderBottom),
				[`borderRight_${borderRight}`]: is(String, borderRight),
				[`borderLeft_${borderLeft}`]: is(String, borderLeft),
				borderRadius: withBorderRadius,
				// position
				[`position_${position}`]: is(String, position),
				position_relative: ref,
				[className]: className
			})}
			style={style}
			ref={ref}
			{...other}
		>
			{children}
		</div>
	)
);

Box.propTypes = {
	className: PropTypes.string,
	displayFlex: PropTypes.bool,
	displayFlexCenter: PropTypes.bool,
	displayFlexCenterSpaceBetween: PropTypes.bool,
	alignItems: PropTypes.oneOf(['center', 'flexStart', 'flexEnd', 'spaceAround', 'spaceBetween']),
	justifyContent: PropTypes.oneOf(['center', 'flexStart', 'flexEnd', 'spaceAround', 'spaceBetween']),
	flexDirection: PropTypes.oneOf(['row', 'rowReverse', 'column', 'columnReverse']),
	flexWrap: PropTypes.oneOf(['wrap', 'noWrap', 'wrapReverse']),
	position: PropTypes.oneOf(['relative', 'absolute']),
	flexGap: PropTypes.string,
	flexGrow: PropTypes.string,
	margin: PropTypes.string,
	marginTop: PropTypes.string,
	marginBottom: PropTypes.string,
	marginRight: PropTypes.string,
	marginLeft: PropTypes.string,
	padding: PropTypes.string,
	paddingTop: PropTypes.string,
	paddingBottom: PropTypes.string,
	paddingRight: PropTypes.string,
	paddingLeft: PropTypes.string,
	border: PropTypes.string,
	borderTop: PropTypes.string,
	borderBottom: PropTypes.string,
	borderRight: PropTypes.string,
	borderLeft: PropTypes.string,
	withBorderRadius: PropTypes.bool,
	children: PropTypes.node,
	style: PropTypes.object
};

export default Box;
